import store from '@/store'

// Appends the shopper's selected country/currency to a GET request URL (as
// country_code) so course/asset/cart/wishlist responses come back priced in
// the right currency. For POST endpoints, merge selectedCountryCode() into
// the request body instead - the backend reads country_code from either.
export function withCountryCode(url) {
    const code = store.getters.selectedCountryCode;
    if (!code) {
        return url;
    }
    const separator = url.includes('?') ? '&' : '?';
    return `${url}${separator}country_code=${code}`;
}

export function selectedCountryCode() {
    return store.getters.selectedCountryCode;
}
